/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import * as React from 'react'
type CheckboxContentProps = {
  label?: string
}
export const CheckboxContent: React.SFC<CheckboxContentProps> = ({ label }) => (
  <span>{label}</span>
)
